import { Next } from '@securitize/ui-components';

export const getInvestorPortfolioNext = new Next('/portfolio', 'GET_INVESTOR_PORTFOLIO');
